import { Line } from '../../../Common/Charts/Line';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCRASChartsDataContext } from './hooks/useIDCRASChartsDataContext';

export const GeneralEvolutionChart = () => {
    const { chartData } = useIDCRASChartsDataContext();
    return (
        <Line
            title="Evolução Anual do IDCRAS"
            subtitles={chartData.general.map((item) => getYearLabel(item.ano))}
            values={chartData.general.map(
                (item) => Number(item.idcras) || 0
            )}
        />
    );
};
